module.exports = __webpack_public_path__ + "images/emoji-thumbs-up.gif";